export const validateChangePasswordWithHookForm = (values: any): any => {
  let errors: any = {
    oldpassword: '',
    newpassword: '',
    confirmPassword: ''
  };
  if (!values.oldpassword || !values.oldpassword.replace(/\s/g, '').length) {
    errors.oldpassword = 'RESET_PASSWORD.OLD_PASSWORD_REQ';
  }
  if (!values.newpassword || !values.newpassword.replace(/\s/g, '').length) {
    errors.newpassword = 'RESET_PASSWORD.NEW_PASSWORD_REQ';
  }
  if (
    !values.confirmPassword ||
    !values.confirmPassword.replace(/\s/g, '').length
  ) {
    errors.confirmPassword = 'RESET_PASSWORD.CONFIRM_NEW_PASSWORD_REQ1';
  }
  if (!values.newpassword) {
    errors.newpassword =
      'RESET_PASSWORD.PROFILE_ICON_CHANGE_PASSWORD_INPUT_FIELD';
  }
  else {
    const upperCaseRg = /[A-Z]/;
    const lowerCaseRg = /[a-z]/;
    const digitRg = /[0-9]/;
    const specialCaseRg = /\W|_/g;
    if (values.newpassword.length < 8 || values.newpassword.length > 15) {
      errors.newpassword = 'RESET_PASSWORD.VALIDATIONS.LENGTH';
    } else if (!upperCaseRg.test(values.newpassword)) {
      errors.newpassword = 'RESET_PASSWORD.VALIDATIONS.UPPER_CASE_LETTER';
    } else if (!lowerCaseRg.test(values.newpassword)) {
      errors.newpassword = 'RESET_PASSWORD.VALIDATIONS.LOWER_CASE_LETTER';
    } else if (!digitRg.test(values.newpassword)) {
      errors.newpassword = 'RESET_PASSWORD.VALIDATIONS.DIGIT';
    } else if (!specialCaseRg.test(values.newpassword)) {
      errors.newpassword = 'RESET_PASSWORD.VALIDATIONS.SPECIAL_CHARACTERS';
    }
  }
  if (values.newpassword !== values.confirmPassword) {
    errors.confirmPassword = 'RESET_PASSWORD.PASSWORDS_NOT_MATCH';
  }
  if (!errors.newpassword && !errors.confirmPassword) {
    errors = {};
  }
  return errors;
};
